import HomeLogo from 'assets/images/Home/Icono_home.svg';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getIndicadoresData } from 'actions/indicadoresHome.actions';
import { Col, Row, Spin } from 'antd';
import { getFileDataUriSvg } from 'utils/file';
import Temporizador from 'components/Temporizador/Temporizador';
import HomeRF from 'assets/images/Home/HomeUserRF/Home_Imagen_RF.svg';
import Indicadores from './components/Indicadores/Indicadores';
import './Home.scss';

export const Home = () => {
  const { data: usuario } = useSelector((state) => state.validarUsuario);
  const [loading, setLoading] = useState(true);
  const [indicatorsData, setIndicatorsData] = useState(null);
  const [lastUpedate, setLastUpdate] = useState(null);
  const [nextUpedate, setNextUpdate] = useState(null);
  const [relojIcon, setRelojIcon] = useState(null);
  const [phoneSimac, setPhoneSimac] = useState(null);
  const [updateView, setUpdateView] = useState(false);

  useEffect(() => {
    const fetchIndicadoresData = async () => {
      try {
        // Inicia la petición al montar el componente en el DOM
        const { success, data } = await getIndicadoresData();
        const {
          imagenesFront,
          indicadoresUsuarios,
          indicadoresMonitoreos,
          indicadoresEventosCasas
        } = data;
        // console.log('response', success, data);
        if (success) {
          const actualConMayuscula =
            data.fechaUltimaActualizacion.charAt(0).toUpperCase() +
            data.fechaUltimaActualizacion.slice(1);
          setLastUpdate(actualConMayuscula);
          setNextUpdate(data?.fechaProximaActualizacion);
          setRelojIcon(imagenesFront[0]?.img_64);
          setPhoneSimac(imagenesFront[1]?.img_64);
          setIndicatorsData([indicadoresUsuarios, indicadoresMonitoreos, indicadoresEventosCasas]);
        }
      } catch (error) {
        console.log('Error en la petición del servicio Indicadores Home', error);
      } finally {
        setLoading(false);
      }
    };

    fetchIndicadoresData();
  }, [updateView]);

  // console.log('indicadores:', indicatorsData);

  const handleGetFileUriSvg = (base64String) => {
    try {
      const dataUri = getFileDataUriSvg(base64String);
      if (dataUri) {
        return dataUri;
      }
      // console.log('URI de datos generada:', dataUri);
      return null;
    } catch (error) {
      console.error('Error al generar URI de datos:', error.message);
      return null;
    }
  };

  return (
    <div className="home-container">
      {!(
        usuario.rol?.includes('SIF.REPRESENTANTEFINANZAS.OC') ||
        usuario.rol?.includes('SIF.REPRESENTANTEFINANZAS.JL')
      ) ? (
        <div className="home-container">
          <div className="header-home-container">
            <div className="header-logo">
              <img className="home-svg" src={HomeLogo} alt="" /> |
            </div>
          </div>
          <div>
            <div className="home-subheader">
              <p className="title-home">¡Te damos la bienvenida al SIMAC!</p>
              <div className="timer-home">
                <Row>
                  <Col span={6}>
                    <img className="timer-img-home" src={handleGetFileUriSvg(relojIcon)} alt="" />
                  </Col>
                  <Col span={18}>
                    <Row>
                      <span className="nextUpdate-home">Próxima actualización</span>
                      <Temporizador targetDate={nextUpedate} updateView={setUpdateView} />
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="header-label-information">
              Consulta información relevante de los monitoreos. Para ver el detalle por estado
              coloca el cursor sobre la tarjeta.
            </div>
          </div>
          <div className="body-home">
            <div className="actualizacion-home">
              <strong>Última actualización:</strong>
              &nbsp;{lastUpedate}
            </div>
            {loading ? (
              <Spin />
            ) : (
              <Col span={24} style={{ padding: '7px 10px 0px 20px' }}>
                <Indicadores
                  indicatorsData={indicatorsData}
                  handphone={phoneSimac}
                  loading={loading}
                  handleGetFileUriSvg={handleGetFileUriSvg}
                />
              </Col>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="header-logo">
            <img className="home-svg" src={HomeLogo} alt="" /> |
          </div>
          <div className="home-rf-container">
            <img src={HomeRF} alt="" width="107%" style={{ objectFit: 'cover', height: '95%' }} />
          </div>
        </>
      )}
    </div>
  );
};

export default Home;
